import { panicInternal } from './shared.js';
export * from 'fp-ts/Refinement';
export const orThrow = (r, e) => (a) => {
    if (!r(a)) {
        throw e();
    }
    return a;
};
export const invariant = (r, details) => (a) => {
    if (!r(a))
        panicInternal(details(a));
    return a;
};
export const orAll = (...refinements) => (a) => refinements.some((ref) => ref(a));
//# sourceMappingURL=refinement.js.map